import { validations } from './validations';

/**
 * Questions about beer content
 */
export const beerContentQuestions = [
  {
    id: 'beer-content',
    question: 'Você costuma consumir conteúdo / informações sobre cervejas?',
    type: 'radio',
    options: [
      { value: 'sim', label: 'Sim' },
      { value: 'não', label: 'Não' },
    ],
    nextQuestion: (answer) => {
      if (answer === 'não') {
        return 'beer-content-beer-club';
      }
      return 'beer-content-source';
    },
    validation: validations.required,
  },
  {
    id: 'beer-content-source',
    question: 'Como você busca informação sobre cerveja?',
    subtitle: 'Escolha até 3',
    type: 'checkbox',
    options: [
      { value: 'blogs especializados', label: 'Blogs especializados' },
      { value: 'facebook', label: 'Facebook' },
      { value: 'grupos de whatsapp', label: 'Grupos de Whatsapp' },
      { value: 'indicações-de-amigos', label: 'Indicações de amigos' },
      { value: 'instagram', label: 'Instagram' },
      { value: 'linkedin', label: 'Linkedin' },
      { value: 'livros e revistas', label: 'Livros e revistas' },
      { value: 'newsletters', label: 'Newsletters' },
      { value: 'podcasts', label: 'Podcasts' },
      { value: 'sites especializados', label: 'Sites especializados' },
      { value: 'tik-tok', label: 'Tik Tok' },
      { value: 'twitter', label: 'Twitter' },
      { value: 'untappd', label: 'Untappd' },
      { value: 'youtube', label: 'Youtube' },
    ],
    allowOther: true,
    nextQuestion: 'beer-content-beer-club',
    minSelections: 1,
    maxSelections: 3,
    validation: validations.checkboxMinMax(1, 3),
  },
  {
    id: 'beer-content-beer-club',
    question: 'Você assina OU assinaria um clube de cervejas?',
    type: 'radio',
    options: [
      { value: 'sim, assino', label: 'Sim, assino' },
      { value: 'não, mas assinaria', label: 'Não, mas assinaria' },
      { value: 'não, e não tenho interesse', label: 'Não, e não tenho interesse' },
    ],
    nextQuestion: (answer) => {
      if (answer === 'não, e não tenho interesse') {
        return 'beer-listening-styles';
      }
      return 'beer-content-beer-club-value';
    },
    validation: validations.required,
  },
  {
    id: 'beer-content-beer-club-value',
    question: 'Qual o valor máximo que você estaria disposto a pagar na assinatura de um clube contendo 4 cervejas / mês (Incluindo frete)?',
    type: 'radio',
    options: [
      { value: 'até 100', label: 'Até R$ 100,00' },
      { value: 'até 150', label: 'Até R$ 150,00' },
      { value: 'até 200', label: 'Até R$ 200,00' },
      { value: 'até 250', label: 'Até R$ 250,00' },
    ],
    nextQuestion: 'beer-listening-styles',
    validation: validations.required,
  }
];
